import React from 'react';
import type { PlanFeatureKey } from './PricingConfig';
import UpgradeButton from './UpgradeButton';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { openPricingModal } from '../utils/url/pricingPath';

type PricingModalButtonProps = {
  feature: PlanFeatureKey | undefined;
} & Pick<
  React.ComponentProps<typeof UpgradeButton>,
  'children' | 'onClick' | 'size' | 'variant'
>;

const PricingModalButton = ({
  feature,
  onClick,
  ...props
}: PricingModalButtonProps) => {
  const dispatch = useAppDispatch();
  const showPricing: React.MouseEventHandler | undefined = feature
    ? (event) => {
        onClick?.(event);
        openPricingModal(dispatch, feature);
      }
    : undefined;
  return <UpgradeButton onClick={showPricing} {...props} />;
};

export default PricingModalButton;
